import { Pipe, PipeTransform } from '@angular/core';

import { clienteCadastros } from '../cliente-cadastro';

@Pipe({
    name: 'clienteCadastro'
})
export class ClienteCadastroPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = clienteCadastros.findIndex(cadastro => cadastro.id === value);
        if (index > -1) {
            return clienteCadastros[index].nome;
        }
        return '';
    }
}
